import { combineReducers } from 'redux-immutable';

import AchievementsReducer from './AchievementsReducer/AchievementsReducer';
import { BaseAchievementsStore } from './AchievementsReducer/AchievementsReducer.types';
import AgreementsReducer from './AgreementsReducer/AgreementsReducer';
import { BaseAgreementsStore } from './AgreementsReducer/AgreementsReducer.types';
import PerformanceReducer from './PerformanceReducer/PerformanceReducer';
import { BasePerformanceStore } from './PerformanceReducer/PerformanceReducer.types';
import UserProfileReducer from './UserReducer/UserProfileReducer';
import { BaseUserProfileStore } from './UserReducer/UserProfileReducer.types';
import { BasePublicProfileStore } from './PublicProfileReducer/PublicProfile.types';
import PublicProfileReducer from './PublicProfileReducer/PublicProfileReducer';

export interface BaseProfileStoreElement {
  achievements: BaseAchievementsStore;
  user: BaseUserProfileStore;
  performance: BasePerformanceStore;
  agreements: BaseAgreementsStore;
  publicProfile: BasePublicProfileStore;
}

export const ProfileReducer = combineReducers<BaseProfileStoreElement>({
  achievements: AchievementsReducer,
  user: UserProfileReducer,
  performance: PerformanceReducer,
  agreements: AgreementsReducer,
  publicProfile: PublicProfileReducer,
});

export interface BaseProfileStore {
  profile: BaseProfileStoreElement;
}
